import ac from 'argument-contracts';
import {
    InputId,
    InputType
} from '@meltwater/inputs';
import { logger } from '../logger';

/**
 * The number of days in 15 months that include a leap year, 2 months with 31
 * days, and 1 month with 30 days; i.e. the maximum number of days possible in
 * any 15 month span.
 */
export const LONGEST_15_MONTHS = 458;

/**
 * The number of days in a leap year; i.e. the maximum number of days possible
 * for any single year.
 */
export const ONE_LEAP_YEAR = 366;

/**
 * Get the maximum number of days an operation should be run for a given input
 * type
 *
 * @param {InputType} inputType - The input type
 * @returns {number} The maximum number of days to allow
 */
export function getDateRangeLimitByInputType (inputType) {
    ac.assertString(inputType, 'inputType');

    switch (inputType) {
        case InputType.AD_HOC:
        case InputType.RSS:
        case InputType.SAVED_SEARCH:
        case InputType.TAG:
            return ONE_LEAP_YEAR;

        case InputType.FACEBOOK_ACCOUNT:
        case InputType.INSTAGRAM_ACCOUNT:
        case InputType.LINKEDIN_ACCOUNT:
        case InputType.TWITTER_ACCOUNT:
        case InputType.YOUTUBE_ACCOUNT:
            return LONGEST_15_MONTHS;

        default:
            logger.warn(`Cannot get date range limit for unknown input type "${inputType}". Defaulting to ${ONE_LEAP_YEAR} days.`);
            return ONE_LEAP_YEAR;
    }
}

/**
 * Get the maximum number of days allowed for every input type in a list of
 * inputs.
 *
 * @param {InputId[]} inputs - The list of inputs
 * @returns {number} The maximum number of days to allow
 */
export function getDateRangeLimitForInputs (inputs) {
    ac.assertArrayOf(inputs, InputId, 'inputs');

    return inputs
        .map(({ type }) => type)
        .map(getDateRangeLimitByInputType)
        .sort()[0];
}
